import { render, staticRenderFns } from "./ArtworkForm.vue?vue&type=template&id=3f423842&scoped=true&"
import script from "./ArtworkForm.vue?vue&type=script&lang=js&"
export * from "./ArtworkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f423842",
  null
  
)

export default component.exports